import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsAI: CultureInfo = {
  name: 'es-AI',
  displayName: 'español (Anguila)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-AI',
  parent: CultureInfoEs
};
